module.exports = __webpack_public_path__ + "static/media/gateway3.bd9c78a8.jpg";